import { i18n as Ii18n } from 'i18next';

export const changeLanguage = (value: string, i18n: Ii18n) => {
  i18n.changeLanguage(value);
};
